<script lang="ts">
	import Posts from '$lib/components/posts.svelte';
	import { onMount } from 'svelte';
	import type { PageData } from './$types';
	import { browser } from '$app/environment';

	export let data: PageData;
	export const { page, posts } = data as PageData & { page: any };

 	onMount(() => {
		if (browser) {
			globalThis.__sharethis__.initialize();
		}
	});
</script>

<svelte:component this={page} />

<section class="mt-4 pt-4 border-t-2 border-neutral-200 dark:border-neutral-800">
	<h3 class="mb-3">Share with your friends</h3>
	<div class="sharethis-inline-share-buttons mb-6" />

	<h3 class="mb-3">Related posts</h3>
	<Posts {posts} />
</section>
